import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { ISubscriptionStatusEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ISubscriptionStatusEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.subscriptionStatus");

export const subscriptionStatus = {
  ...getAllApis,
};
